import { keyframes } from '@emotion/react'
import { Box, Typography } from '@mui/material'
import styled from '@emotion/styled'
import { colors, typography } from '@resiliatech/birdsong'

export const NeedsAssessmentTriggerContainer = styled(Box)`
  display: flex;
  flex-direction: column;
  gap: 24px;
  padding: 0 0 100px 0;
`

export const Actions = styled(Box)`
  align-items: center;
  display: flex;
  gap: 20px;
`

export const Header = styled(Typography)`
  ${typography.up3.semiBoldSans}
`

export const Text = styled(Typography)`
  ${typography.baseline.regularSans}
`

const fadeOut = keyframes`
    from {
        opacity: 1
    }
    to {
        opacity: 0
    }
`

export const ErrorMessage = styled(Text)`
  animation: ${fadeOut} 6s ease-in-out forwards;
  animation-delay: 4s;
  color: ${colors.feedback.errorDark};
  opacity: 1;
`

export const SuccessMessage = styled(Text)`
  animation: ${fadeOut} 6s ease-in-out forwards;
  animation-delay: 4s;
  color: ${colors.feedback.successDark};
  opacity: 1;
`

export const Feedback = styled(Box)`
  display: flex;
  gap: 20px;
`
